import { render, staticRenderFns } from "./ItemAchievement.vue?vue&type=template&id=47b67fcb&"
import script from "./ItemAchievement.vue?vue&type=script&lang=js&"
export * from "./ItemAchievement.vue?vue&type=script&lang=js&"
import style0 from "./ItemAchievement.vue?vue&type=style&index=0&id=47b67fcb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports